import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
export const HeroSection = memo(function HeroSection() {
  const CHECKOUT_URL = 'https://checkout.construyeprogreso.com/cart/48181622702250:1';
  return <section className="relative overflow-hidden min-h-screen flex items-center justify-center px-4 pt-14 pb-20" data-id="element-57">
      {/* Background */}
      <img src="https://cdn.magicpatterns.com/uploads/ehXocraeJf13oboyH8uykq/ChatGPT_Image_1_abr_2026,_01_47_02.webp" alt="Fondo domina tu mente" fetchPriority="high" loading="eager" decoding="async" width="1456" height="816" className="absolute inset-0 w-full h-full object-cover opacity-30" data-id="element-58" />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/80 via-white/70 to-white/95" data-id="element-59" />
      <div className="absolute inset-0 bg-gradient-to-t from-white via-white/40 to-transparent opacity-80" data-id="element-60" />

      {/* Contenido */}
      <div className="relative z-10 text-center w-full max-w-sm md:max-w-4xl mx-auto flex flex-col items-center gap-2" data-id="element-61">
        {/* Badge */}
        <div className="inline-block bg-yellow-50 border border-yellow-200 text-yellow-600 text-[10px] md:text-xs font-bold uppercase tracking-[0.15em] px-5 py-2 rounded-full mb-4 backdrop-blur-sm shadow-sm" data-id="element-62">
          🧠 De Coma Digital a Ejecución Total — El Sistema Completo de Rescate
          Mental
        </div>

        {/* Título Principal */}
        <h1 className="font-black leading-none tracking-tight mb-4" data-id="element-63">
          <span className="block text-[30px] md:text-6xl lg:text-7xl text-gray-900 mb-3 leading-[1.1] drop-shadow-sm" data-id="element-64">
            Recuperá tu Enfoque desde Cero <br className="hidden md:block" data-id="element-65" />y{' '}
            <span className="text-yellow-500" data-id="element-66">
              Convertite en Alguien que Ejecuta.
            </span>
          </span>
          <span className="block text-[14px] md:text-xl lg:text-2xl text-gray-600 font-semibold mt-5 leading-relaxed max-w-3xl mx-auto px-2 uppercase tracking-wider" data-id="element-67">
            Desde dominar tu mañana hasta <br className="hidden md:block" data-id="element-68" />
            recuperar{' '}
            <strong className="text-yellow-500" data-id="element-69">
              4 horas diarias de foco puro
            </strong>{' '}
            y convertirlas en resultados reales.
          </span>
        </h1>

        {/* Mockup */}
        <a href={CHECKOUT_URL} className="animate-float block my-6 w-full max-w-[280px] md:max-w-[480px] mx-auto group" data-id="element-70">
          <img src="https://cdn.magicpatterns.com/uploads/esaYEPBsX8nHGwjfPijHwV/hf_20260407_225646_4f439bc4-2c86-4e7d-bf53-4276584bf216_(1).webp" alt="Megapack Domina Tu Mente — De Coma Digital a Ejecución Total" className="w-full transition-all duration-500
              drop-shadow-[0_20px_50px_rgba(0,0,0,0.2)]
              group-hover:drop-shadow-[0_25px_60px_rgba(234,179,8,0.15)]
              group-hover:scale-[1.03]
              group-hover:brightness-105" width="1456" height="816" fetchPriority="high" loading="eager" decoding="async" data-id="element-71" />
        </a>

        {/* CTA */}
        <CTAButton href={CHECKOUT_URL} text="🧠 QUIERO DOMINAR MI MENTE" subtext="🔒 Pago seguro · Acceso inmediato · Garantía 30 días" data-id="element-72" />
      </div>
    </section>;
});